import { render, staticRenderFns } from "./DisciplinaryViolations.vue?vue&type=template&id=776e45e0"
import script from "./DisciplinaryViolations.vue?vue&type=script&lang=js"
export * from "./DisciplinaryViolations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports